import 'reflect-metadata';
import {
  container,
  instancePerContainerCachingFactory,
  registry,
} from 'tsyringe';
import {
  kNameOfPromotionWindowService,
  IPromotionWindowService,
} from '../shared/interfaces/promotion-window-service.interface';
import {
  kNameOfUserActionService,
  IUserActionService,
} from '../shared/interfaces/user-action-service.interface';
import { LoggerService } from '../shared/services/logger.service';
import { WindowsTunnelDataService } from '../shared/services/windows-tunnel-data.service';
import { PromotionController } from './promotion.controller';
import './promotion.scss';
// import { Sentry } from '../shared/utils/sentry';

// -----------------------------------------------------------------------------
@registry([
  {
    token: kNameOfPromotionWindowService,
    useFactory: instancePerContainerCachingFactory<IPromotionWindowService>(
      (c) => {
        const tunnelDataService = c.resolve(WindowsTunnelDataService);
        return tunnelDataService.get(kNameOfPromotionWindowService);
      },
    ),
  },
  {
    token: kNameOfUserActionService,
    useFactory: instancePerContainerCachingFactory<IUserActionService>((c) => {
      const tunnelDataService = c.resolve(WindowsTunnelDataService);
      return tunnelDataService.get(kNameOfUserActionService);
    }),
  },
])
// eslint-disable-next-line @typescript-eslint/no-unused-vars, no-unused-vars
class PromotionRegistry {}

// -----------------------------------------------------------------------------
const startup = () => {
  // Sentry.initSentry();
  LoggerService.setup('Overwolf Promotions');
  const controller = container.resolve(PromotionController);
  controller.run();
};

startup();
